import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { ThemeContext } from "../Themes/ThemeContext";
import ailogolight from "../assets/ailogolight.png";
import ailogodark from "../assets/ailogodark.png";
import "./Footer.css";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

const LEGAL_LINKS = [
  { to: "/terms-conditions", label: "Terms & Conditions" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/refund-cancellation", label: "Refund & Cancellation" },
  { to: "/shipment-billing", label: "Shipment & Billing" },
];

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <footer className="footer-modern">
      <div className="footer-modern-grid">
        <div className="footer-brand">
          <img src={theme === "light" ? ailogolight : ailogodark} alt="AI4Bazaar" className="footer-logo" />
          <p className="footer-brand-desc">
            AI4Bazaar by VISYS Cloud Technologies — helping local businesses go online with affordable, professional websites.
          </p>
          <div className="footer-social">
            <a href="https://www.facebook.com/people/Cloud4CoolKids/61560383229805/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://x.com/i/flow/login?redirect_after_login=%2Fcloud4coolkids" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://www.instagram.com/cloud4coolkids/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/cloud4coolkids/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>{QUICK_LINKS.map((l) => (
            <li key={l.label}><Link to={l.to} onClick={() => window.scrollTo(0, 0)}>{l.label}</Link></li>
          ))}</ul>
        </div>

        <div className="footer-col">
          <h4>Legal</h4>
          <ul>{LEGAL_LINKS.map((l) => (
            <li key={l.label}><Link to={l.to} onClick={() => window.scrollTo(0, 0)}>{l.label}</Link></li>
          ))}</ul>
        </div>

        <div className="footer-col footer-contact">
          <h4>Contact</h4>
          <div className="footer-contact-item">
            <FaMapMarkerAlt />
            <div>
              <strong>India Office</strong>
              <p>QHub Madhapur, 4th Floor, near Madhapur Metro Station, Madhapur, Hyderabad, Telangana 500033</p>
            </div>
          </div>
          <div className="footer-contact-item">
            <FaMapMarkerAlt />
            <div>
              <strong>USA Office</strong>
              <p>8720 Silverado Trail, Suite 207, McKinney, TX 75070</p>
            </div>
          </div>
          <div className="footer-contact-item">
            <FaPhone />
            <div>
              <a href="tel:+919392014678">+91 9392014678</a>
              <span> · </span>
              <a href="tel:+12015815271">+1 201-581-5271</a>
            </div>
          </div>
          <div className="footer-contact-item">
            <FaEnvelope />
            <div>
              <a href="mailto:support@ai4bazaar.com">support@ai4bazaar.com</a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 <a href="https://visyscloudtech.com/">VISYS Cloud Technologies India</a>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
